export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  longDescription: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  views: number;
  favorites: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '全部', slug: 'all', image: '' },
  { name: '恋爱', slug: 'romance', image: 'https://readdy.ai/api/search-image?query=A%20soft%20romantic%20Korean%20manhwa%20style%20scene%20with%20two%20lovers%20under%20cherry%20blossoms%2C%20warm%20pink%20tones%2C%20gentle%20lighting%2C%20dreamy%20atmosphere%2C%20clean%20composition&width=400&height=200&seq=cat-romance&orientation=landscape' },
  { name: '奇幻', slug: 'fantasy', image: 'https://readdy.ai/api/search-image?query=A%20magical%20fantasy%20Korean%20manhwa%20scene%20with%20floating%20castles%20and%20glowing%20crystals%2C%20warm%20golden%20light%2C%20ethereal%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20art&width=400&height=200&seq=cat-fantasy&orientation=landscape' },
  { name: '动作', slug: 'action', image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20Korean%20manhwa%20scene%20with%20a%20warrior%20in%20mid-combat%2C%20dramatic%20warm%20lighting%2C%20energy%20effects%2C%20clean%20composition%2C%20professional%20digital%20art&width=400&height=200&seq=cat-action&orientation=landscape' },
  { name: '悬疑', slug: 'mystery', image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20atmospheric%20Korean%20manhwa%20scene%20with%20shadows%20and%20silhouettes%2C%20dark%20alley%20at%20night%2C%20warm%20streetlight%2C%20moody%20composition%2C%20professional%20digital%20art&width=400&height=200&seq=cat-mystery&orientation=landscape' },
  { name: '搞笑', slug: 'comedy', image: 'https://readdy.ai/api/search-image?query=A%20funny%20lighthearted%20Korean%20manhwa%20style%20scene%20with%20exaggerated%20expressions%2C%20bright%20playful%20colors%2C%20comedic%20situation%2C%20warm%20lighting%2C%20clean%20composition&width=400&height=200&seq=cat-comedy&orientation=landscape' },
  { name: '校园', slug: 'school', image: 'https://readdy.ai/api/search-image?query=A%20bright%20Korean%20manhwa%20school%20scene%20with%20students%20in%20uniforms%20walking%20through%20a%20sunny%20campus%2C%20cherry%20blossom%20trees%2C%20warm%20afternoon%20light%2C%20clean%20composition&width=400&height=200&seq=cat-school&orientation=landscape' },
  { name: '都市', slug: 'urban', image: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20Korean%20manhwa%20scene%20with%20city%20skyline%20and%20neon%20lights%2C%20young%20professionals%2C%20warm%20evening%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20art&width=400&height=200&seq=cat-urban&orientation=landscape' },
  { name: '古风', slug: 'historical', image: 'https://readdy.ai/api/search-image?query=An%20elegant%20historical%20Korean%20manhwa%20palace%20scene%20with%20traditional%20architecture%2C%20flowing%20hanbok%20robes%2C%20warm%20lantern%20light%2C%20moonlit%20garden%2C%20clean%20composition&width=400&height=200&seq=cat-historical&orientation=landscape' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'the-legendary-moonlight-sculptor',
    title: '月光雕刻师',
    author: '李贤民',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20with%20silver%20hair%20holding%20a%20glowing%20sculpting%20tool%20under%20moonlight%2C%20fantasy%20setting%20with%20magical%20particles%2C%20soft%20ethereal%20lighting%2C%20clean%20background%20with%20warm%20tones%2C%20professional%20digital%20art%20style%2C%20vertical%20composition&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '一个普通大学生在虚拟现实游戏《皇家之路》中，凭借非凡的雕刻技艺和坚韧意志，从一无所有成长为传奇冒险者的故事。',
    longDescription: '平凡的大学青年李贤，因家境贫困而进入虚拟现实游戏《皇家之路》寻求生计。在游戏中，他选择了无人问津的雕刻师职业，却意外发现了这个职业背后隐藏的巨大潜力。凭借惊人的毅力和独特的创造力，他雕刻出栩栩如生的雕像，召唤传说中的生物，一步步揭开游戏隐藏的秘密。从负债累累的穷学生到游戏世界的传奇人物，李贤的冒险充满了热血、智慧与感动。本作以其宏大的世界观、细腻的人物刻画和扣人心弦的剧情，成为韩国漫画史上的经典之作。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['虚拟现实', '游戏', '冒险', '成长'],
    rating: 4.8,
    views: 12500000,
    favorites: 890000,
    status: '连载中',
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c1-1', title: '第1话 命运的起点', number: 1, updatedAt: '2024-01-15' },
      { id: 'c1-2', title: '第2话 雕刻师之路', number: 2, updatedAt: '2024-01-22' },
      { id: 'c1-3', title: '第3话 初露锋芒', number: 3, updatedAt: '2024-01-29' },
      { id: 'c1-180', title: '第180话 月光之巅', number: 180, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: '2',
    slug: 'solo-leveling',
    title: '我独自升级',
    author: '张成乐',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20striking%20Korean%20manhwa%20cover%20featuring%20a%20dark-haired%20hunter%20with%20glowing%20purple%20eyes%20and%20a%20black%20trench%20coat%2C%20surrounded%20by%20shadow%20soldiers%2C%20dramatic%20lighting%20against%20a%20dark%20dungeon%20backdrop%2C%20intense%20and%20powerful%20atmosphere%2C%20high-quality%20digital%20art&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '在一个充满怪物的世界里，被称为"人类最弱兵器"的成振宇，在一次生死危机后获得了独一无二的"升级系统"，从此踏上成为最强猎人的道路。',
    longDescription: '十年前，连接异次元的"传送门"突然出现，怪物涌入人类世界。部分人类觉醒了特殊能力，被称为"猎人"。成振宇是E级猎人，实力弱小却从未放弃。在一次双重地下城事故中，他濒临死亡，却意外获得了神秘的"系统"，成为唯一能够通过任务升级变强的存在。从最弱到最强，振宇的秘密任务不仅关乎个人命运，更牵动着整个世界的存亡。本作以爽快的战斗场面、紧凑的剧情节奏和震撼的视觉表现力，风靡全球漫画市场。',
    category: '动作',
    categorySlug: 'action',
    tags: ['系统', '升级', '猎人', '爽文'],
    rating: 4.9,
    views: 28000000,
    favorites: 2100000,
    status: '已完结',
    updatedAt: '2025-12-20',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c2-1', title: '第1话 最弱的猎人', number: 1, updatedAt: '2023-03-10' },
      { id: 'c2-2', title: '第2话 双重地下城', number: 2, updatedAt: '2023-03-17' },
      { id: 'c2-200', title: '第200话 终章·新的开始', number: 200, updatedAt: '2025-12-20' },
    ],
  },
  {
    id: '3',
    slug: 'true-beauty',
    title: '女神降临',
    author: '喵喵',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20pretty%20Korean%20manhwa%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20brown%20hair%20and%20flawless%20makeup%20holding%20a%20compact%20mirror%2C%20soft%20romantic%20lighting%2C%20pastel%20color%20palette%2C%20school%20uniform%2C%20clean%20minimal%20background%2C%20shojo%20style%20digital%20art&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '因为长相平凡而自卑的女生林周京，通过化妆技巧华丽变身校园女神，在两个帅气男生之间展开了一段甜蜜又纠结的青春恋爱故事。',
    longDescription: '林周京从小因为外貌受到欺凌，转学后她决定用化妆改变自己的人生。凭借精湛的化妆技术，她摇身一变成为校园里的"女神"，吸引了全校的目光。然而在素颜与化妆之间，她小心翼翼地隐藏着真实的自己。当她遇到了唯一见过她素颜却毫不在意的神秘校草李修豪，以及阳光开朗的校霸韩书俊，一场关于美丽、自信与真爱的青春故事就此展开。本作以细腻的画风、真实的情感刻画和幽默的情节，成为女性向漫画的现象级作品。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['化妆', '校园', '恋爱', '成长'],
    rating: 4.7,
    views: 20000000,
    favorites: 1500000,
    status: '已完结',
    updatedAt: '2025-10-15',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c3-1', title: '第1话 转学生', number: 1, updatedAt: '2023-05-20' },
      { id: 'c3-2', title: '第2话 化妆的力量', number: 2, updatedAt: '2023-05-27' },
      { id: 'c3-180', title: '第180话 真正的美丽', number: 180, updatedAt: '2025-10-15' },
    ],
  },
  {
    id: '4',
    slug: 'tower-of-god',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20tower%20reaching%20into%20the%20sky%20with%20a%20young%20boy%20with%20brown%20hair%20standing%20at%20the%20entrance%2C%20fantasy%20Korean%20manhwa%20style%2C%20epic%20scale%2C%20golden%20and%20warm%20color%20tones%2C%20mystical%20atmosphere%2C%20detailed%20digital%20illustration&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '为了追寻唯一的挚友蕾哈尔，少年二十五夜进入了神秘而危险的神之塔。每一层塔都是一个新的世界，充满了未知的考验与强大的对手。',
    longDescription: '二十五夜是一个生活在塔外黑暗世界的少年，他唯一的寄托就是少女蕾哈尔。当蕾哈尔决定进入传说中的神之塔寻找星空时，二十五夜毫不犹豫地追随她的脚步。塔的每一层都是一个独立的世界，有着截然不同的环境、文化和统治者。在这里，夜结识了形形色色的伙伴——聪明狡黠的昆·阿圭罗、强大忠诚的雷克·莱克里斯，还有无数的敌人与盟友。登塔之旅不仅是对力量的考验，更是对信念、友情和爱的终极试炼。本作以其独创的世界观、复杂的人物关系和层层递进的谜题而备受推崇。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['塔', '冒险', '友情', '谜题'],
    rating: 4.8,
    views: 18000000,
    favorites: 1300000,
    status: '连载中',
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c4-1', title: '第1话 塔的入口', number: 1, updatedAt: '2022-08-10' },
      { id: 'c4-550', title: '第550话 新的试炼', number: 550, updatedAt: '2026-08-02' },
    ],
  },
  {
    id: '5',
    slug: 'the-beginning-after-the-end',
    title: '绝世武神',
    author: 'TurtleMe',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20boy%20with%20silver%20hair%20and%20sharp%20eyes%20wielding%20a%20magical%20sword%20in%20a%20fantasy%20world%2C%20Korean%20manhwa%20art%20style%2C%20dynamic%20pose%2C%20magical%20energy%20surrounding%20him%2C%20epic%20fantasy%20setting%20with%20castles%20and%20dragons%2C%20warm%20golden%20lighting%2C%20professional%20illustration&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '前世是绝世强者的格雷，带着记忆重生到魔法与剑的世界。拥有前世全部经验的他，从婴儿时期就开始了超越所有人的修炼之路。',
    longDescription: '格雷·莱文生前是统治一个王国的绝世强者，却遭到最信任的部下背叛而陨落。当他再次睁开眼睛时，发现自己重生为一个贵族家庭的婴儿，来到了一个充满了魔法与剑气的全新世界。带着前世的全部记忆和战斗经验，格雷从蹒跚学步起就开始了超越常人的修炼。然而这个看似和平的大陆，暗流涌动，隐藏着威胁整个世界的危机。为了保护新的家人和朋友，格雷必须变得比前世更强。一场关于力量、责任与重生的史诗传奇就此拉开帷幕。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['重生', '魔法', '剑术', '修炼'],
    rating: 4.7,
    views: 15000000,
    favorites: 980000,
    status: '连载中',
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c5-1', title: '第1话 重生', number: 1, updatedAt: '2023-08-15' },
      { id: 'c5-160', title: '第160话 觉醒', number: 160, updatedAt: '2026-08-01' },
    ],
  },
  {
    id: '6',
    slug: 'lookism',
    title: '看脸时代',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20split%20face%20illustration%20showing%20a%20handsome%20Korean%20high%20school%20student%20and%20an%20overweight%20student%20side%20by%20side%2C%20symbolizing%20dual%20identity%2C%20dramatic%20contrast%2C%20modern%20school%20setting%2C%20Korean%20manhwa%20style%2C%20social%20commentary%20theme%2C%20warm%20lighting&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '因为外貌丑陋而备受欺凌的朴亨硕，某天醒来发现自己拥有了另一具完美帅气的身体。从此他开始在两个身体之间切换，体验着截然不同的人生。',
    longDescription: '朴亨硕因为肥胖和长相在学校遭受严重的校园霸凌，最终被迫转学。然而在他准备开始新生活的第一天，他惊讶地发现自己在睡着时会变成一具高大帅气的完美身体。白天他以帅气的身体过着光鲜亮丽的生活，夜晚则回归原本的身体。两个身体、两种人生，让他逐渐看清了这个"看脸"的世界的残酷真相。本作不仅是一部校园漫画，更是对当代社会外貌歧视、阶级差异和青少年成长的深刻反思，以其犀利的视角和饱满的人物群像赢得了广泛好评。',
    category: '校园',
    categorySlug: 'school',
    tags: ['双身', '校园', '社会', '成长'],
    rating: 4.6,
    views: 16000000,
    favorites: 1100000,
    status: '连载中',
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c6-1', title: '第1话 新身体', number: 1, updatedAt: '2023-01-10' },
      { id: 'c6-420', title: '第420话 真相', number: 420, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: '7',
    slug: 'wind-breaker',
    title: '御风而行',
    author: '赵容锡',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20showing%20a%20young%20male%20cyclist%20speeding%20on%20a%20racing%20bike%20through%20city%20streets%2C%20wind%20in%20his%20hair%2C%20intense%20focused%20expression%2C%20motion%20blur%20effect%2C%20urban%20night%20setting%20with%20neon%20lights%2C%20sports%20theme%2C%20energetic%20vibe&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '模范学生赵夏岚偶然接触到了自行车竞技的世界，从此踏上了一条充满速度与激情的道路。在风驰电掣中，他找到了真正的自我。',
    longDescription: '赵夏岚是所有人眼中的完美学生——成绩第一、担任班长、性格温和。但在内心深处，他一直渴望突破既定的框架。一次偶然的机会，他被卷入了一场街头自行车赛，那种风驰电掣的快感瞬间点燃了他内心的火焰。从此，他白天是模范学生，夜晚则是街头赛车场上的风云人物。在这条新的人生道路上，他遇到了势均力敌的对手、可靠的队友和一起追逐梦想的伙伴。自行车竞技不仅是速度的比拼，更是意志和信念的碰撞。',
    category: '动作',
    categorySlug: 'action',
    tags: ['自行车', '竞技', '青春', '热血'],
    rating: 4.5,
    views: 10000000,
    favorites: 720000,
    status: '连载中',
    updatedAt: '2026-07-30',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c7-1', title: '第1话 风的呼唤', number: 1, updatedAt: '2023-06-01' },
      { id: 'c7-380', title: '第380话 决赛', number: 380, updatedAt: '2026-07-30' },
    ],
  },
  {
    id: '8',
    slug: 'sweet-home',
    title: '甜蜜家园',
    author: '金坎比',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Korean%20thriller%20manhwa%20cover%20showing%20an%20apartment%20building%20with%20broken%20windows%2C%20a%20young%20man%20with%20determined%20eyes%20holding%20a%20makeshift%20weapon%2C%20monster%20silhouettes%20in%20the%20shadows%2C%20survival%20horror%20theme%2C%20dark%20moody%20lighting%2C%20intense%20atmosphere&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '在末日般的世界中，公寓楼的幸存者们必须与因欲望而变为怪物的人类战斗。少年车贤秀在绝望中守护着最后的家园。',
    longDescription: '一场神秘的灾难席卷世界，人类会因为内心深处的欲望而变异为可怕的怪物。车贤秀是一个失去家人的孤独少年，他独自住在破旧的绿色家园公寓中。当灾难爆发时，公寓成为了幸存者们最后的堡垒。在这里，贤秀遇到了形形色色的人——坚强勇敢的消防员姐姐、神秘的轮椅大叔、还有同样孤独的邻居们。面对不断来袭的怪物和人性深处的黑暗，他们必须团结一致，守护这个名为"家"的地方。本作以其独特的世界观、深刻的人性探讨和令人窒息的紧张感，被誉为韩国惊悚漫画的巅峰之作。',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['末日', '怪物', '生存', '人性'],
    rating: 4.7,
    views: 14000000,
    favorites: 950000,
    status: '已完结',
    updatedAt: '2025-03-15',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c8-1', title: '第1话 公寓', number: 1, updatedAt: '2023-09-01' },
      { id: 'c8-140', title: '第140话 家园', number: 140, updatedAt: '2025-03-15' },
    ],
  },
  {
    id: '9',
    slug: 'eleceed',
    title: '超能继承者',
    author: '孙济镐',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20playful%20Korean%20manhwa%20cover%20featuring%20a%20young%20man%20with%20orange%20hair%20and%20a%20fat%20white%20cat%20with%20electric%20sparks%20around%20it%2C%20superpower%20theme%2C%20bright%20and%20energetic%20vibe%2C%20action%20comedy%20style%2C%20clean%20colorful%20background%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '拥有闪电超能力的少年陈智宇，在一次意外中救下了一只神秘的白色肥猫。这只猫不仅会说话，还是一位隐藏在世界背后的超能力者。',
    longDescription: '陈智宇是一个天生拥有超快速度的少年，他小心翼翼地隐藏着自己的能力过着普通的生活。直到有一天，他从车轮下救出了一只圆滚滚的白色肥猫。这只自称"凯登"的猫竟然是被困在猫身体里的传奇超能力者！从此，智宇被卷入了超能力者的隐秘世界。在这个世界里，有维护秩序的组织，有野心勃勃的势力，还有各种各样的超能力者。智宇在凯登的指导下不断成长，结识了志同道合的伙伴，也逐渐揭开了这个世界的真相。本作以幽默轻松的风格、精彩的战斗场面和温暖的人物关系而广受欢迎。',
    category: '动作',
    categorySlug: 'action',
    tags: ['超能力', '猫', '战斗', '喜剧'],
    rating: 4.6,
    views: 11000000,
    favorites: 820000,
    status: '连载中',
    updatedAt: '2026-08-02',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c9-1', title: '第1话 那只猫', number: 1, updatedAt: '2023-11-05' },
      { id: 'c9-250', title: '第250话 觉醒之力', number: 250, updatedAt: '2026-08-02' },
    ],
  },
  {
    id: '10',
    slug: 'the-remarried-empress',
    title: '再婚皇后',
    author: 'Alpha Tart',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elegant%20Korean%20manhwa%20cover%20showing%20a%20noble%20empress%20with%20long%20blonde%20hair%20in%20a%20luxurious%20gown%2C%20standing%20in%20a%20palace%20hall%2C%20regal%20and%20composed%20expression%2C%20historical%20fantasy%20setting%2C%20warm%20golden%20lighting%2C%20romance%20drama%20theme%2C%20detailed%20digital%20art&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '帝国皇后娜菲尔在丈夫公然背叛后，做出了一个震惊所有人的决定——她要求离婚，并接受了邻国国王的求婚，成为他的再婚皇后。',
    longDescription: '娜菲尔是东方帝国的完美皇后，她才华横溢、贤良淑德，却始终得不到丈夫苏维许皇帝的爱。当皇帝公然将一个来历不明的女子带上皇后的位置时，娜菲尔做出了改变命运的决定——她向皇帝提出了离婚。更令人震惊的是，她接受了邻国国王亨利的求婚。亨利国王年轻英俊、温柔体贴，但他身上隐藏着不为人知的秘密。在新的国度里，娜菲尔不仅要面对政治阴谋，还要重新学习如何去爱与被爱。本作以精致的画风、复杂的人物关系和跌宕起伏的宫廷权谋，成为女性向古风漫画的经典。',
    category: '古风',
    categorySlug: 'historical',
    tags: ['宫廷', '皇后', '再婚', '权谋'],
    rating: 4.8,
    views: 19000000,
    favorites: 1400000,
    status: '连载中',
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c10-1', title: '第1话 皇后的决心', number: 1, updatedAt: '2023-07-20' },
      { id: 'c10-160', title: '第160话 新的开始', number: 160, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: '11',
    slug: 'omniscient-readers-viewpoint',
    title: '全知读者视角',
    author: 'Sing N Song',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20showing%20an%20ordinary%20office%20worker%20surrounded%20by%20floating%20text%20and%20holographic%20screens%20in%20a%20post-apocalyptic%20world%2C%20fantasy%20sci-fi%20blend%2C%20intense%20expression%2C%20dramatic%20lighting%2C%20warm%20golden%20accents%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '金独子是一个平凡的上班族，也是连载了十年的冷门小说《在灭亡的世界中生存的三种方法》的唯一忠实读者。当小说中的末日真正降临，他成为了唯一知道剧情走向的人。',
    longDescription: '金独子是一个普通的公司职员，他唯一的爱好就是阅读一部连载了十年的网络小说《在灭亡的世界中生存的三种方法》。这部小说读者寥寥，但金独子却是它的忠实粉丝，追更了整整3149话。就在小说完结的那一天，世界突然变成了小说中描述的末日场景。怪物横行、系统降临，而金独子是唯一知道这个故事全部剧情的人。凭借对小说的了解，他开始在这个末日世界中挣扎求存，与小说主角相遇，甚至试图改变既定的命运。但随着故事的发展，他发现这个世界的真相远比小说更加复杂和残酷。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['末日', '小说', '系统', '生存'],
    rating: 4.9,
    views: 17000000,
    favorites: 1250000,
    status: '连载中',
    updatedAt: '2026-08-01',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c11-1', title: '第1话 唯一的读者', number: 1, updatedAt: '2023-08-01' },
      { id: 'c11-200', title: '第200话 剧情之外', number: 200, updatedAt: '2026-08-01' },
    ],
  },
  {
    id: '12',
    slug: 'secret-class',
    title: '秘密教学',
    author: '王作家',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20featuring%20a%20handsome%20young%20male%20tutor%20and%20a%20pretty%20female%20student%20sitting%20close%20together%20in%20a%20cozy%20study%20room%2C%20soft%20warm%20lighting%2C%20intimate%20atmosphere%2C%20romance%20drama%20theme%2C%20clean%20background%2C%20professional%20digital%20art&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '为了偿还家里的债务，天才大学生林在宇成为了富家千金的家教。但这场看似寻常的教学关系，逐渐演变成了一段危险的秘密恋情。',
    longDescription: '林在宇是首尔大学的高材生，因家庭变故背负了巨额债务。为了生存，他接受了为富家千金徐雅凛担任家教的兼职。徐雅凛外表高傲冷漠，实则内心孤独脆弱。在一次次的教学中，两人之间萌生了超越师生关系的情感。然而阶层差距、家族压力和隐藏的秘密，让这段感情充满了挑战。在宇必须在责任与爱情之间做出选择，而雅凛也要学会为自己的幸福而战。本作以精致的画风和细腻的情感刻画，打动了无数读者的心。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['家教', '恋爱', '阶层', '秘密'],
    rating: 4.4,
    views: 9500000,
    favorites: 680000,
    status: '连载中',
    updatedAt: '2026-07-28',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c12-1', title: '第1话 家教', number: 1, updatedAt: '2023-10-01' },
      { id: 'c12-120', title: '第120话 告白', number: 120, updatedAt: '2026-07-28' },
    ],
  },
  {
    id: '13',
    slug: 'mercenary-enrollment',
    title: '佣兵入学',
    author: '柳贺岚',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20showing%20a%20young%20man%20in%20school%20uniform%20with%20a%20cold%20expression%20and%20battle%20scars%2C%20holding%20a%20gun%20in%20one%20hand%20and%20books%20in%20the%20other%2C%20military%20mercenary%20theme%20blending%20with%20school%20life%2C%20dual%20identity%20concept%2C%20warm%20dramatic%20lighting%2C%20professional%20digital%20art&width=600&height=800&seq=manga-cover-13&orientation=portrait',
    description: '从战场上归来的少年佣兵俞真，为了完成最后的任务——像普通人一样高中毕业。然而过去的阴影和新的危险不断追随着他。',
    longDescription: '俞真在很小的时候遭遇飞机失事，流落到了一个战火纷飞的地区，被一名佣兵收养。在那里，他学会了战斗、生存，成为了令敌人闻风丧胆的少年佣兵。十年后，他终于回到了韩国，唯一的愿望就是完成祖父的心愿——像一个普通少年一样高中毕业。然而融入普通高中生活比他想象的要困难得多，过去的敌人也追踪而来。在保护同学和处理校园问题的同时，俞真逐渐找回了失去的日常。本作以精彩的动作场面和温暖的情感描绘，成为校园动作漫画的代表作。',
    category: '动作',
    categorySlug: 'action',
    tags: ['佣兵', '校园', '战斗', '日常'],
    rating: 4.6,
    views: 13000000,
    favorites: 900000,
    status: '连载中',
    updatedAt: '2026-07-31',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c13-1', title: '第1话 归国', number: 1, updatedAt: '2023-06-15' },
      { id: 'c13-180', title: '第180话 毕业', number: 180, updatedAt: '2026-07-31' },
    ],
  },
  {
    id: '14',
    slug: 'who-made-me-a-princess',
    title: '某天成为公主',
    author: 'Plutus',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20showing%20a%20young%20princess%20with%20long%20blonde%20hair%20and%20sparkling%20blue%20eyes%20wearing%20an%20ornate%20pink%20dress%2C%20standing%20in%20a%20magical%20palace%20garden%2C%20soft%20fairy%20tale%20atmosphere%2C%20warm%20gentle%20lighting%2C%20romantic%20fantasy%20theme&width=600&height=800&seq=manga-cover-14&orientation=portrait',
    description: '一个现代女孩穿越到了自己读过的小说中，成为了注定要被亲生父亲杀死的悲剧公主阿塔纳西娅。为了改变命运，她开始了艰难的求生计划。',
    longDescription: '一个热爱小说的现代女孩在一次意外中穿越到了自己最爱的爱情小说中，却成为了书中命运最悲惨的角色——被自己的父亲、冷酷无情的皇帝克劳德处死的公主阿塔纳西娅。深知剧情走向的她，决定不惜一切代价改变自己的命运。她小心翼翼地讨好父亲，收集珍贵的魔法物品，甚至准备逃离皇宫。然而随着与父亲的相处，她发现这个冷酷皇帝内心深处的温柔和伤痛。与此同时，来自邻国的王子、神秘的魔法师纷纷出现在她的生命中。命运的车轮能否被逆转？',
    category: '古风',
    categorySlug: 'historical',
    tags: ['穿越', '公主', '父女', '命运'],
    rating: 4.7,
    views: 17000000,
    favorites: 1200000,
    status: '连载中',
    updatedAt: '2026-07-29',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c14-1', title: '第1话 穿越', number: 1, updatedAt: '2023-04-10' },
      { id: 'c14-150', title: '第150话 真相', number: 150, updatedAt: '2026-07-29' },
    ],
  },
  {
    id: '15',
    slug: 'medical-return',
    title: '医者归来',
    author: '柳真',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20featuring%20a%20young%20doctor%20in%20a%20white%20coat%20with%20a%20stethoscope%2C%20confident%20smile%2C%20standing%20in%20a%20modern%20hospital%20corridor%2C%20medical%20drama%20theme%2C%20clean%20professional%20setting%2C%20warm%20bright%20lighting%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-15&orientation=portrait',
    description: '碌碌无为的外科医生金振宇在一次医疗事故后回到过去。带着三十年的医术经验，他决定这次要成为真正顶尖的医生。',
    longDescription: '金振宇是一个平庸的外科医生，在经历了三十年的医疗生涯后，因为一次致命的医疗事故而身败名裂。在绝望之际，他奇迹般地回到了自己的高中时代。带着前世积累的三十年医学知识和经验，他重新进入了医科大学。这一次，他不再满足于做一个普通的医生。凭借超前的医学见解和精湛的手术技巧，他震惊了整个医学界。从医学生到世界级外科医生，金振宇用第二次人生弥补了所有的遗憾。本作以专业详实的医学知识和热血励志的成长故事，吸引了大量读者。',
    category: '都市',
    categorySlug: 'urban',
    tags: ['医疗', '重生', '成长', '励志'],
    rating: 4.5,
    views: 11000000,
    favorites: 780000,
    status: '连载中',
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c15-1', title: '第1话 重生', number: 1, updatedAt: '2023-07-01' },
      { id: 'c15-140', title: '第140话 世界舞台', number: 140, updatedAt: '2026-08-01' },
    ],
  },
  {
    id: '16',
    slug: 'the-greatest-estate-developer',
    title: '地产大亨',
    author: '李贤民',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20manhwa%20cover%20showing%20a%20greedy-looking%20young%20man%20with%20exaggerated%20expressions%20holding%20blueprints%20and%20gold%20coins%2C%20construction%20and%20real%20estate%20theme%2C%20comedy%20style%2C%20bright%20colorful%20background%2C%20warm%20lighting%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-16&orientation=portrait',
    description: '土木工程系学生金秀浩穿越到中世纪奇幻世界，凭借现代工程知识成为了这个世界的房地产大亨。但他赚钱的方式，总是让周围人目瞪口呆。',
    longDescription: '土木工程系的大学生金秀浩某天醒来发现自己穿越到了剑与魔法的中世纪奇幻世界。在这里，他意外获得了可以召唤现代工程设备的能力。别人穿越都是成为勇者或魔法师，但秀浩选择了一条前所未闻的道路——搞房地产！他利用工程知识改良土地、修建房屋、建造城堡，甚至开创了这个世界的下水道系统。他贪婪又搞笑的赚钱方式让贵族们又爱又恨，也让这个奇幻世界发生了翻天覆地的变化。本作以夸张幽默的风格和脑洞大开的剧情，成为韩国搞笑漫画中的一匹黑马。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['穿越', '地产', '工程', '搞笑'],
    rating: 4.7,
    views: 14000000,
    favorites: 1000000,
    status: '连载中',
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c16-1', title: '第1话 穿越', number: 1, updatedAt: '2023-09-15' },
      { id: 'c16-130', title: '第130话 王国第一', number: 130, updatedAt: '2026-08-03' },
    ],
  },
  {
    id: '17',
    slug: 'dr-brain',
    title: '天才大脑',
    author: '洪作家',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20thriller%20manhwa%20cover%20showing%20a%20brain%20surgeon%20with%20intense%20eyes%20surrounded%20by%20floating%20brain%20diagrams%20and%20neural%20networks%2C%20psychological%20thriller%20theme%2C%20dark%20moody%20lighting%20with%20warm%20accents%2C%20scientific%20horror%20atmosphere%2C%20professional%20digital%20art&width=600&height=800&seq=manga-cover-17&orientation=portrait',
    description: '天才脑科学家李信在进行记忆移植实验时，意外发现自己的大脑中存在着不属于自己的记忆。一场关于身份、记忆与真相的探索之旅就此展开。',
    longDescription: '李信是韩国最杰出的脑科学家，他主导的研究项目致力于将人的记忆进行数字化转移。当实验进入人体试验阶段时，李信开始出现奇怪的记忆碎片——他不曾经历过的事情、不认识的人、从未去过的地方，却异常清晰。随着调查的深入，他发现这些记忆属于多年前一起悬案的受害者。而更令人毛骨悚然的是，这些记忆似乎正在取代他原本的意识。李信必须在自己的意识彻底消失之前，找出真相。本作融合了脑科学、悬疑推理和心理惊悚元素，扣人心弦。',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['脑科学', '记忆', '悬疑', '心理'],
    rating: 4.5,
    views: 8500000,
    favorites: 610000,
    status: '已完结',
    updatedAt: '2025-08-20',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c17-1', title: '第1话 实验', number: 1, updatedAt: '2023-11-01' },
      { id: 'c17-90', title: '第90话 真相', number: 90, updatedAt: '2025-08-20' },
    ],
  },
  {
    id: '18',
    slug: 'study-group',
    title: '学习小组',
    author: '申炯旭',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20showing%20a%20group%20of%20tough-looking%20high%20school%20students%20with%20books%20and%20pens%20in%20hand%2C%20but%20with%20fighting%20stances%2C%20action%20comedy%20school%20theme%2C%20contrast%20between%20studying%20and%20fighting%2C%20bright%20daytime%20setting%2C%20warm%20tones%2C%20professional%20digital%20art&width=600&height=800&seq=manga-cover-18&orientation=portrait',
    description: '在韩国最混乱的高中里，一群想要好好学习的学生组成了"学习小组"。但在这个连老师都怕学生的地方，认真学习本身就是一场战斗。',
    longDescription: '柳城高中是全韩国出了名的"问题高中"，打架斗殴是日常，认真学习反而成了怪事。尹佳敏是一个真心想要考上好大学的学生，但他所在的高中根本不是一个能安心学习的地方。为了守护自己的学习权利，他组建了一个特殊的"学习小组"——成员个个都是打架高手，但都有着想要好好学习的共同目标。白天他们在教室里击退捣乱的人，晚上则埋头苦读。在这个疯狂的高中里，学习和战斗并行不悖。本作以独特的设定和热血搞笑的剧情赢得了大量读者喜爱。',
    category: '校园',
    categorySlug: 'school',
    tags: ['高中', '学习', '战斗', '友情'],
    rating: 4.6,
    views: 10500000,
    favorites: 750000,
    status: '连载中',
    updatedAt: '2026-07-30',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c18-1', title: '第1话 问题高中', number: 1, updatedAt: '2023-10-10' },
      { id: 'c18-110', title: '第110话 期末考', number: 110, updatedAt: '2026-07-30' },
    ],
  },
  {
    id: '19',
    slug: 'lore-olympus',
    title: '奥林匹斯传说',
    author: 'Rachel Smythe',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean-style%20manhwa%20cover%20depicting%20a%20beautiful%20pink-haired%20goddess%20Persephone%20and%20a%20dark-haired%20Hades%20in%20a%20modern-greek%20mythology%20setting%2C%20romantic%20fantasy%2C%20warm%20ethereal%20lighting%2C%20golden%20accents%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-19&orientation=portrait',
    description: '以现代视角重新演绎希腊神话，讲述春之女神珀耳塞福涅与冥王哈迪斯之间跨越神界的浪漫爱情故事。华丽的画风搭配现代感的叙事。',
    longDescription: '希腊诸神生活在现代奥林匹斯，拥有着现代的生活方式却保持着古老的权力结构。珀耳塞福涅是丰收女神德墨忒尔过度保护的女儿，她来到奥林匹斯开始大学生活。在众神云集的派对上，她邂逅了冥界之王哈迪斯。一个是从未被世俗污染的春之女神，一个是被误解已久的孤独冥王。他们的相遇引发了一系列连锁反应，牵扯出诸神之间复杂的关系网、古老的恩怨和隐藏的秘密。在神与人之间、在光明与黑暗之间，这段不被看好的爱情能否战胜一切？',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['希腊神话', '现代', '恋爱', '诸神'],
    rating: 4.8,
    views: 16000000,
    favorites: 1150000,
    status: '连载中',
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c19-1', title: '第1话 春之女神', number: 1, updatedAt: '2023-09-01' },
      { id: 'c19-240', title: '第240话 冥界之约', number: 240, updatedAt: '2026-08-02' },
    ],
  },
  {
    id: '20',
    slug: 'leveling-up-with-the-gods',
    title: '与神升级',
    author: '黑亚仁',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20showing%20a%20warrior%20climbing%20a%20massive%20tower%20with%20gods%20watching%20from%20above%2C%20divine%20beings%20with%20golden%20light%2C%20epic%20fantasy%20scale%2C%20warm%20divine%20lighting%2C%20professional%20digital%20illustration%2C%20action%20theme&width=600&height=800&seq=manga-cover-20&orientation=portrait',
    description: '人类在与神灵的战争中失败后，被放逐到一座无尽高塔中。少年金赫作为最后的觉醒者，获得了与神灵对抗的力量，开始了攀登高塔的复仇之旅。',
    longDescription: '很久以前，人类与神灵之间爆发了一场旷世大战。人类战败，幸存者被放逐到了一座无尽的高塔之中。每一层塔都是一个残酷的试炼场，只有不断变强、不断攀登，才能活下去。少年金赫出生在塔的底层，从小就展现了非凡的战斗天赋。在觉醒仪式上，他获得了传说中曾经对抗神灵的"弑神者"的力量。从此，金赫踏上了攀登高塔的征途，目标只有一个——到达塔顶，向那些高高在上的神灵讨回人类的尊严与自由。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['神灵', '高塔', '觉醒', '复仇'],
    rating: 4.6,
    views: 12000000,
    favorites: 850000,
    status: '连载中',
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c20-1', title: '第1话 底层', number: 1, updatedAt: '2023-12-01' },
      { id: 'c20-100', title: '第100话 神域', number: 100, updatedAt: '2026-08-01' },
    ],
  },
  {
    id: '21',
    slug: 'city-of-blank',
    title: '空白都市',
    author: '柳城敏',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20urban%20fantasy%20manhwa%20cover%20showing%20a%20sleek%20city%20skyline%20at%20night%20with%20neon%20lights%2C%20a%20young%20man%20and%20woman%20in%20fashionable%20clothing%20standing%20on%20a%20rooftop%2C%20mysterious%20atmosphere%2C%20romance%20drama%20theme%2C%20warm%20neon%20lighting%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-21&orientation=portrait',
    description: '在首尔的繁华都市中，有一群"空白者"——他们没有过去、没有身份、没有社会记录。当普通大学生李由美意外卷入这个隐秘世界，一切都变了。',
    longDescription: '在首尔这座璀璨的现代都市背后，存在着一个不为人知的群体——"空白者"。他们是没有身份记录、不存在于任何数据库中的幽灵般的存在。李由美是一名普通的艺术大学学生，在一次深夜回家的路上，她意外目睹了一场追杀，救下了一个受伤的神秘男子。这个男子正是一名"空白者"。从此，由美被卷入了一场涉及政府黑幕、科技犯罪和人性挣扎的巨大漩涡。在这个空白都市中，她不仅要寻找真相，更要守护自己的良知和所爱之人。',
    category: '都市',
    categorySlug: 'urban',
    tags: ['都市', '神秘', '身份', '悬疑'],
    rating: 4.4,
    views: 7500000,
    favorites: 520000,
    status: '连载中',
    updatedAt: '2026-07-28',
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: 'c21-1', title: '第1话 深夜', number: 1, updatedAt: '2026-05-01' },
      { id: 'c21-25', title: '第25话 空白者', number: 25, updatedAt: '2026-07-28' },
    ],
  },
  {
    id: '22',
    slug: 'spirit-farmer',
    title: '精灵农场',
    author: '金素月',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20wholesome%20Korean%20manhwa%20cover%20showing%20a%20young%20woman%20in%20overalls%20smiling%20while%20holding%20magical%20plants%20on%20a%20farm%2C%20tiny%20cute%20spirits%20floating%20around%2C%20warm%20sunny%20day%2C%20healing%20fantasy%20theme%2C%20soft%20pastel%20colors%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-22&orientation=portrait',
    description: '厌倦了都市生活的白领林小鱼辞职回到乡下，却意外发现自己能看见精灵。在精灵的帮助下，她开始了温馨治愈的农场生活。',
    longDescription: '林小鱼在首尔做了五年的社畜，每天加班到深夜，过着看不到希望的生活。在又一次通宵加班后，她毅然递交了辞职信，回到了外婆留下的乡间老屋。让她震惊的是，当她走进老屋的后院时，竟然看到了飞舞的植物精灵！原来她们家族世代都是"精灵守护者"。在精灵的帮助下，小鱼学会了种植奇妙的魔法作物——会唱歌的花朵、散发安眠香气的草药、能治愈伤痛的果实。她开设了一个小小的"精灵农场"，吸引了许多被都市生活折磨的人们前来寻求治愈。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['精灵', '农场', '治愈', '日常'],
    rating: 4.5,
    views: 8000000,
    favorites: 580000,
    status: '连载中',
    updatedAt: '2026-08-02',
    isHot: false,
    isNew: true,
    isRecommended: true,
    chapters: [
      { id: 'c22-1', title: '第1话 辞职', number: 1, updatedAt: '2026-04-15' },
      { id: 'c22-30', title: '第30话 收获祭', number: 30, updatedAt: '2026-08-02' },
    ],
  },
  {
    id: '23',
    slug: 'doom-breaker',
    title: '末日破坏者',
    author: '青鹿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20manhwa%20cover%20showing%20a%20fierce%20warrior%20with%20a%20scar%20on%20his%20face%20swinging%20a%20massive%20sword%20against%20monsters%20in%20a%20destroyed%20city%2C%20apocalyptic%20setting%2C%20dramatic%20warm%20lighting%20with%20fire%20and%20smoke%2C%20intense%20action%20atmosphere%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-23&orientation=portrait',
    description: '世界末日降临后，人类最后的堡垒面临崩溃。从未来回到过去的战士齐寒星，必须集结散落在世界各地的觉醒者，共同对抗末日浩劫。',
    longDescription: '末日降临的那一天，天空裂开，怪物涌入，人类文明几乎在一夜之间崩塌。齐寒星是人类最后的堡垒"曙光城"的守护者之一，在最终决战中，他亲眼目睹了所有战友的牺牲。在绝望之际，他触发了一件古老的遗物，获得了回到末日降临前十年的机会。带着未来的记忆和战斗经验，齐寒星回到了那个看似一切正常的时代。他必须找到并说服那些在未来成为觉醒者的人们，在末日降临之前组建起一支能够扭转命运的军队。',
    category: '动作',
    categorySlug: 'action',
    tags: ['末日', '回归', '战斗', '觉醒'],
    rating: 4.5,
    views: 9000000,
    favorites: 650000,
    status: '连载中',
    updatedAt: '2026-07-29',
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: 'c23-1', title: '第1话 最后的堡垒', number: 1, updatedAt: '2026-05-20' },
      { id: 'c23-22', title: '第22话 觉醒者', number: 22, updatedAt: '2026-07-29' },
    ],
  },
  {
    id: '24',
    slug: 'mystic-pop-up-bar',
    title: '神秘路边摊',
    author: '裴惠秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20magical%20Korean%20manhwa%20cover%20showing%20a%20mysterious%20woman%20in%20traditional%20hanbok%20serving%20drinks%20at%20a%20vibrant%20neon-lit%20street%20food%20stall%20at%20night%2C%20supernatural%20theme%2C%20warm%20cozy%20lighting%2C%20magical%20atmosphere%2C%20professional%20digital%20illustration&width=600&height=800&seq=manga-cover-24&orientation=portrait',
    description: '在首尔的深夜街头，有一家只在午夜开门的神秘路边摊。摊主月珠能进入客人的梦境，为他们解开心中郁结。而每个客人的故事，都藏着人性的温暖。',
    longDescription: '首尔的深夜，当大多数人都已入睡，一家散发着神秘暖光的路边摊悄然开张。摊主月珠是一个活了五百年的神秘女子，因为前世的罪孽而被罚在人间为十万人的梦境解忧。她能通过一杯特制的酒进入客人的梦境，看到他们内心最深的伤痛和遗憾。每一夜，都有形形色色的客人来到摊前——失意的白领、心碎的老人、迷茫的年轻人、孤独的孩子。月珠用她独特的方式，帮助他们面对内心的恐惧、解开心中的结。而在这个过程中，她自己背负了五百年的痛苦，也在慢慢地被治愈。',
    category: '都市',
    categorySlug: 'urban',
    tags: ['治愈', '梦境', '奇幻', '人间'],
    rating: 4.7,
    views: 10000000,
    favorites: 730000,
    status: '已完结',
    updatedAt: '2025-06-30',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c24-1', title: '第1话 午夜开张', number: 1, updatedAt: '2023-04-01' },
      { id: 'c24-120', title: '第120话 最后的客人', number: 120, updatedAt: '2025-06-30' },
    ],
  },
];

export const featuredComics = comics.filter(c => c.isRecommended);
export const hotComics = comics.filter(c => c.isHot);
export const newComics = comics.filter(c => c.isNew);

export const getComicsByCategory = (categorySlug: string) => {
  if (categorySlug === 'all') return comics;
  return comics.filter(c => c.categorySlug === categorySlug);
};

export const getComicBySlug = (slug: string) => {
  return comics.find(c => c.slug === slug);
};

export const getRelatedComics = (comic: Comic, limit = 6) => {
  return comics
    .filter(c => c.id !== comic.id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
};